export const retouchPreviewVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
    
    v_texCoord = a_texCoord;
}
`;

export const retouchPreviewFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

// Mask texture (mask stored in alpha channel)
uniform sampler2D u_texture0;

// 0..1 preview opacity multiplier
uniform float u_opacity;

out vec4 outColor;

void main() {
  float m = texture(u_texture0, v_texCoord).a;
  m = clamp(m, 0.0, 1.0);

  // Make preview edge crisp (not blurry) while keeping 1px AA.
  // Note: this affects ONLY the preview; the actual healing still uses the original feathered mask.
  float edge = 0.15; // lower = thicker stroke in preview
  float aa = max(1e-4, fwidth(m) * 1.75);
  float fill = smoothstep(edge - aa, edge + aa, m);

  float a = fill * clamp(u_opacity, 0.0, 1.0);
  outColor = vec4(0.0, 0.0, 0.0, a);
}
` as const;
